module.exports = __webpack_public_path__ + "img/c01_unittechpalintononchampion_Normal_ua.120220c9.webp";